type GenericObject = Record<string, any>;

/**
 * @description Save data into browser localStorage
 */
export const saveToLocal = (key: string, data: GenericObject | string, isJson = true): void => {
  const saveData = data && isJson ? JSON.stringify(data) : (data as string);
  localStorage.setItem(key, saveData);
};

/**
 * @description Get data from browser localStorage
 */
export const getFromLocal = (key: string, isJson = true): GenericObject | string | null => {
  const data = localStorage.getItem(key);
  if (data && isJson) {
    try {
      return JSON.parse(data);
    } catch {
      return null;
    }
  }
  return data;
};

/**
 * @description Remove data from browser localStorage
 */
export const removeFromLocal = (key: string): void => {
  localStorage.removeItem(key);
};
